import { useMtgConditions } from '../../../application/bloc/useMtgConditions';
import { useMtgSelect } from '../../../application/bloc/useMtgSelect';
import { FloatingBox, SideBox, Height60, FlexBox2 } from '../../etc/LBox/LBox';
import {
  HeadTitle,
  SelectField,
  Spacer,
  Button,
  MenuBottomsheet,
  TextButton,
  TextField,
  Tmd14,
  TheSearchBottomsheet,
} from 'oui';

import { currencyKR } from '../../../application/helper/filter';
import { useEffect, useState } from 'react';
import { ClkBtnSubEventNm } from '../../../application/hooks/useBeacon';

export const MtgSelect = () => {
  const {
    navigateNextStep,
    selectSheet,
    openSelectSheet,
    mortgageInfo,
    onChangeWrappingInput,
    onChangeInput,
    saveInputInfoTemp,
  } = useMtgConditions();
  const {
    isActive,
    housePriceWarning,
    setHousePriceWarning,
    hopefulAmtWarning,
    setHopefulAmtWarning,
    sendBeaconClkBtnOption,
    sendBeaconClkBtnUnkAddressDtl,
    sendBeaconClkBtn,
    getLdongList,
    searchApartment,
    searchRateSeq,
  } = useMtgSelect();

  const onClickButton = () => {
    let properties = {
      hope_loan_amount: mortgageInfo.hopefulAmt,
    } as any;
    if (mortgageInfo?.houseType.value === '30') {
      properties.market_price = mortgageInfo.housePrice;
    }
    sendBeaconClkBtn(ClkBtnSubEventNm.Next, properties);
    void saveInputInfoTemp();
    navigateNextStep('PUSH');
  };
  const onClickSelectField = (type: string) => {
    openSelectSheet(type);
  };

  const resetDefaultInfo = () => {
    onChangeInput({ key: 'isRegulation', value: false });
    onChangeInput({ key: 'dong', value: '' });
    onChangeInput({ key: 'ho', value: '' });
    onChangeInput({ key: 'housePrice', value: '' });
    onChangeInput({ key: 'hopefulAmt', value: '' });
    onChangeInput({
      key: 'unkAddress',
      value: 'N',
    });
    setAreaList([]);
    onChangeWrappingInput({ key: 'apartment', text: '', value: '' });
    onChangeWrappingInput({ key: 'rateSeq', text: '', value: '' });
    onChangeWrappingInput({ key: 'floor', text: '', value: '' });
  };

  const loadAreaList = async (apartment: string) => {
    const response = await searchRateSeq(apartment);
    setAreaList(() => {
      return response;
    });
  };

  const onChangeMenuBottomsheet = async (e: any) => {
    // 다세대 / 연립주택 법정동 선택 케이스
    if (e.fullNm && !e.pldongCode) {
      void (await onClickLdongField({
        title: '시/군/구',
        ldongCode: e.value,
        stateNm: 'ldongCode',
      }));
      return;
    }
    // 아파트 법정동 선택 케이스
    if (
      e.fullNm &&
      e.pldongCode &&
      (mortgageInfo?.houseType.value === '10' ||
        mortgageInfo?.houseType.value === '20')
    ) {
      const isEnd: boolean = await onClickLdongFieldFromDong({
        title: '읍/면/동',
        ldongCode: e.value,
        stateNm: 'ldongCode',
      });
      if (isEnd) {
        const list: any = await searchApartment('', e.value);
        openSelectSheet('', {
          title:
            mortgageInfo.houseType.value === '10'
              ? `${e.text || '대출 받을'} 아파트`
              : `${e.text || '대출 받을'} 오피스텔`,
          stateNm: 'apartment',
          items: list,
        });
        return;
      }
    }
    // 아파트 선택 시 평수 리스트 저장
    if (selectSheet.stateNm === 'apartment') {
      loadAreaList(e.value);
    }

    // 평수 선택 시 최저 시세 저장 케이스
    if (selectSheet.stateNm === 'rateSeq') {
      onChangeInput({ key: 'housePrice', value: e.amt });
      onClickSelectField('C050');
    }

    // 주택유형 변경시 기존 정보 reset
    if (selectSheet.stateNm === 'houseType') {
      if (e.value !== mortgageInfo.houseType.value) {
        resetDefaultInfo();
        onChangeWrappingInput({ key: 'apartment', text: '', value: '' });
        onChangeWrappingInput({ key: 'ldongCode', text: '', value: '' });
      }
      if (e.value !== '30') {
        onClickApartmentField();
      } else {
        onClickLdongField({ title: '주택 시/도', stateNm: 'ldongCode' });
      }
    }

    onChangeWrappingInput({
      key: selectSheet.stateNm,
      text: e.fullNm || e.text,
      value: e.value,
    });

    if (selectSheet.title) {
      sendBeaconClkBtnOption({
        btmsheet_name: selectSheet.title,
        option_name: e.fullNm || e.text,
        before_option_name: mortgageInfo[selectSheet.stateNm]?.text ?? '',
      });
    }
  };

  const onClickLdongField = async (item?: any) => {
    const list = await getLdongList(item.ldongCode);
    openSelectSheet('', {
      title: item.title,
      stateNm: item.stateNm,
      items: list,
    });
  };
  const onClickLdongFieldFromDong = async (item?: any) => {
    const list = await getLdongList(item.ldongCode);
    if (list.length > 0) {
      openSelectSheet('', {
        title: item.title,
        stateNm: item.stateNm,
        items: list,
      });
    }
    return !(list.length > 0);
  };
  const [isOpenSearch, setOpenSearch] = useState<boolean>(false);
  const onClickApartmentField = async () => {
    setOpenSearch(true);
  };
  const [areaList, setAreaList] = useState<any[]>([]);

  useEffect(() => {
    if (areaList && areaList.length > 0)
      onClickAreaField({ title: '평수 (공급/전용)', stateNm: 'rateSeq' });
  }, [areaList]);
  const onClickApartmentItem = async (item: any) => {
    if (mortgageInfo.apartment.value == item.value) {
      return;
    }

    resetDefaultInfo();

    if (item.isRegulation) {
      onChangeInput({ key: 'isRegulation', value: item.isRegulation });
    }

    if (item.ldongCode) {
      onChangeWrappingInput({
        key: 'ldongCode',
        text: '',
        value: item.ldongCode,
      });
    }

    onChangeWrappingInput({
      key: 'apartment',
      text: item.name,
      value: item.code,
    });

    sendBeaconClkBtn(ClkBtnSubEventNm.HouseList, {
      btmsheet_name: '주택 주소',
      house_name: item.name,
    });

    if (item.code) {
      const response = await searchRateSeq(item.code);
      setAreaList(() => {
        return response;
      });
    }
  };
  const onClickAreaField = (item: any) => {
    if (!areaList || areaList.length <= 0) {
      if (mortgageInfo?.apartment?.value) {
        // 만약 평수 목록이 없다면 평수 목록을 불러온다.
        loadAreaList(mortgageInfo.apartment.value);
      }
    }

    openSelectSheet('', {
      title: item.title,
      stateNm: item.stateNm,
      items: areaList,
    });
  };
  const onClickUnkAddress = () => {
    onChangeInput({ key: 'dong', value: '' });
    onChangeInput({ key: 'ho', value: '' });
    onChangeInput({
      key: 'unkAddress',
      value: mortgageInfo.unkAddress === 'Y' ? 'N' : 'Y',
    });
    //
    sendBeaconClkBtnUnkAddressDtl();
    document.getElementById('hopefulAmt')?.focus();
  };

  const onClickManualSelect = () => {
    resetDefaultInfo();
    onChangeWrappingInput({
      key: 'houseType',
      text: '아파트',
      value: '40',
    });
    onChangeWrappingInput({ key: 'floor', text: '3층 이상', value: '30' });

    selectSheet.onClose();
  };

  const validateAmt = (value?: string) => {
    if (!value)
      return {
        validate: true,
        amt: '',
      };

    let amt = value.replace(/,/g, '');
    if (!amt) {
      return {
        validate: true,
        amt: '',
      };
    }

    if (amt.length > 1 && amt.substring(0, 1) === '0') amt = amt.substring(1);
    const num = Number(amt);
    if (isNaN(num))
      return {
        validate: false,
      };
    if (num === 0 && amt.length > 1)
      return {
        validate: false,
      };

    if (amt.length > 6)
      return {
        validate: false,
      };

    return {
      validate: true,
      amt: amt,
    };
  };

  const Space = () => (
    <>
      <Spacer size="md" />
    </>
  );

  return (
    <>
      <HeadTitle
        textTitle={'담보로 할 주택 정보와\n대출 희망 금액을 입력해 주세요'}
        subTitle={'전체 정보 중 50%를 완료했어요'}
      />
      <Spacer size={'xs'} />
      <SideBox>
        <SelectField
          inputTitle="주택 유형"
          value={mortgageInfo.houseType.text}
          placeholder={'주택 유형'}
          onChangeSelectField={() => {}}
          onClickSelectField={() => onClickSelectField('C046')}
        />
        {mortgageInfo?.houseType.value && (
          <>
            {mortgageInfo?.houseType.value === '10' ||
            mortgageInfo?.houseType.value === '20' ? (
              // 아파트, 오피스텔
              <>
                <Space />
                <SelectField
                  inputTitle="주소"
                  value={mortgageInfo.apartment.text}
                  placeholder={'주택 주소'}
                  onChangeSelectField={() => {}}
                  onClickSelectField={onClickApartmentField}
                  warning={mortgageInfo.isRegulation}
                  warningText={
                    '규제 지역 주택입니다. LTV비율이 낮을 수 있어요.'
                  }
                />
                <Space />
                <SelectField
                  inputTitle="평수"
                  value={mortgageInfo.rateSeq.text}
                  placeholder={'평수 (공급/전용)'}
                  onChangeSelectField={() => {}}
                  onClickSelectField={() =>
                    onClickAreaField({
                      title: '평수 (공급/전용)',
                      stateNm: 'rateSeq',
                    })
                  }
                />
                <Space />
                <SelectField
                  inputTitle="층수"
                  value={mortgageInfo.floor.text}
                  placeholder={'층수'}
                  onChangeSelectField={() => {}}
                  onClickSelectField={() => onClickSelectField('C050')}
                />
                <Space />
                <FlexBox2>
                  <TextField
                    inputTitle="동"
                    placeholder={'예.123'}
                    state={'enabled'}
                    inputMode={'numeric'}
                    adornment={'동'}
                    value={mortgageInfo.dong ?? ''}
                    disabled={mortgageInfo.unkAddress === 'Y' ? true : false}
                    onChangeTextInput={(value) => {
                      const amt = value.replace(/,/g, '');
                      if (amt.length > 4) return;
                      onChangeInput({ key: 'dong', value });
                    }}
                  />
                  <div style={{ width: 40 }} />
                  <TextField
                    inputTitle="호"
                    placeholder={'예.123'}
                    state={'enabled'}
                    adornment={'호'}
                    inputMode={'numeric'}
                    value={mortgageInfo.ho ?? ''}
                    onBlur={(e) => {
                      document.getElementById('hopefulAmt')?.focus();
                    }}
                    disabled={mortgageInfo.unkAddress === 'Y' ? true : false}
                    onChangeTextInput={(value) => {
                      const amt = value.replace(/,/g, '');
                      if (amt.length > 4) return;
                      onChangeInput({ key: 'ho', value });
                    }}
                  />
                </FlexBox2>
                <Spacer size="xs" />
                <TextButton
                  state={
                    mortgageInfo.unkAddress === 'Y' ? 'focused' : 'enabled'
                  }
                  size={'md'}
                  text={'동 호수를 몰라요'}
                  iconLeft={{
                    name: 'CheckCircle',
                  }}
                  iconColor={'primary'}
                  onClickButton={onClickUnkAddress}
                />
              </>
            ) : (
              // 연립/다세대, 아파트 가격 직접 입력
              <>
                <Space />
                <SelectField
                  inputTitle="주택 지역"
                  value={mortgageInfo.ldongCode.text}
                  placeholder={'주택 시/도'}
                  onChangeSelectField={() => {}}
                  onClickSelectField={() =>
                    onClickLdongField({
                      title: '주택 시/도',
                      stateNm: 'ldongCode',
                    })
                  }
                />

                <Space />
                <TextField
                  inputTitle="주택 가격"
                  placeholder={'0'}
                  state={'enabled'}
                  adornment={'만 원'}
                  inputMode={'numeric'}
                  helperText={currencyKR(mortgageInfo?.housePrice * 10000)}
                  value={mortgageInfo.housePrice ?? ''}
                  warning={
                    housePriceWarning
                      ? '주택 가격보다 많은 금액을 대출 받을 수 없어요'
                      : ''
                  }
                  onChangeTextInput={(value) => {
                    const { validate, amt } = validateAmt(value);
                    if (validate) {
                      const hopefulAmt = Number(mortgageInfo.hopefulAmt);
                      const housePrice = Number(amt);
                      if (
                        !isNaN(hopefulAmt) &&
                        !isNaN(housePrice) &&
                        hopefulAmt > 0 &&
                        housePrice > 0 &&
                        hopefulAmt >= housePrice
                      ) {
                        setHousePriceWarning(true);
                      } else {
                        setHousePriceWarning(false);
                      }

                      onChangeInput({ key: 'housePrice', value: amt });
                    }
                  }}
                  hasClearButton
                />
              </>
            )}
            <Space />
            <TextField
              inputTitle="대출 희망 금액"
              placeholder={'0'}
              state={'enabled'}
              adornment={'만 원'}
              inputMode={'numeric'}
              id={'hopefulAmt'}
              helperText={currencyKR(mortgageInfo?.hopefulAmt * 10000)}
              value={mortgageInfo.hopefulAmt ?? ''}
              warning={
                hopefulAmtWarning
                  ? '주택 가격보다 많은 금액을 대출 받을 수 없어요'
                  : ''
              }
              onChangeTextInput={(value) => {
                const { validate, amt } = validateAmt(value);
                if (validate) {
                  const hopefulAmt = Number(amt);
                  const housePrice = Number(mortgageInfo.housePrice);
                  if (
                    !isNaN(hopefulAmt) &&
                    !isNaN(housePrice) &&
                    hopefulAmt > 0 &&
                    housePrice > 0 &&
                    hopefulAmt >= housePrice
                  ) {
                    setHopefulAmtWarning(true);
                  } else {
                    setHopefulAmtWarning(false);
                  }

                  onChangeInput({ key: 'hopefulAmt', value: amt });
                }
              }}
              hasClearButton
            />
          </>
        )}
      </SideBox>
      <Height60 />
      <Spacer size="lg" />
      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          isDisabled={!isActive}
          state={isActive ? 'enabled' : 'disabled'}
          children={'다음'}
          onClick={onClickButton}
        />
      </FloatingBox>

      <MenuBottomsheet
        selectType="instant"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        subTitle={selectSheet.subTitle}
        items={selectSheet.items}
        onClickMenuItem={(e: any) => {
          selectSheet.onClose();
          void onChangeMenuBottomsheet(e);
        }}
        isMaxHeight={
          selectSheet.stateNm === 'ldongCode' ||
          selectSheet.stateNm === 'apartment' ||
          selectSheet.stateNm === 'rateSeq'
        }
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        defaultValue={mortgageInfo[selectSheet.stateNm]}
        bottomButton={
          selectSheet.stateNm === 'apartment' &&
          mortgageInfo?.houseType.value === '10'
            ? {
                desc: '찾으시는 아파트가 없으신가요?',
                buttonText: '주택가격 입력하기',
                onClick: onClickManualSelect,
              }
            : undefined
        }
      />
      <TheSearchBottomsheet
        onSearchCompany={searchApartment}
        isSearchBottomsheetOpen={isOpenSearch}
        title={'주택 주소'}
        value={mortgageInfo.apartment.text as string}
        placeholder={'지역 명 / 아파트 이름'}
        hasClearButton
        showIsLoading
        onClose={() => setOpenSearch(false)}
        onRegistCompany={onClickApartmentItem}
        onClickRegister={() => {
          setOpenSearch(false);
          void onClickLdongField({ title: '주택 시/도', stateNm: 'ldongCode' });
        }}
      />
    </>
  );
};
